import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { DepartmentI } from '../interfaces/department.interface';
import { RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { ToastService } from '../../../core/services/toast/toast.service';
import { CardI } from '../../../shared/interfaces/card.interface';
import { DelegatedUIErrorI } from '../../../shared/interfaces/delegated-ui-error.interface';
import { DepartmentsApisService } from '../departments-apis.service';
import { DepartmentsService } from '../departments.service';
import { DepartmentsDetailsSideMenuComponent } from './departments-details-side-menu/departments-details-side-menu.component';
import { DepartmentsCards } from '../constants/departments-cards.constant';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-departments-details',
  imports: [TranslateModule, RouterOutlet, DepartmentsDetailsSideMenuComponent],
  templateUrl: './departments-details.component.html',
  styleUrl: './departments-details.component.scss',
})
export class DepartmentsDetailsComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly translateService = inject(TranslateService);
  private readonly toastService = inject(ToastService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly departmentsApisService = inject(DepartmentsApisService);
  private readonly departmentsService = inject(DepartmentsService);
  private destroyRef = inject(DestroyRef);

  departmentsCard: CardI[] = DepartmentsCards;
  departmentID: string | undefined = undefined;
  selectedDepartment: DepartmentI | null = null;
  limit = 15;

  ngOnInit() {
    this.getDepartmentIDFromRouteParams();
  }

  getDepartmentIDFromRouteParams() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((paramMap) => {
        const departmentID = paramMap.get('departmentID');
        if (!departmentID) {
          this.toastService.showError(
            this.translateService.instant('errors.contactTechnicalSupport')
          );
        } else {
          this.departmentID = departmentID;
          this.fetchProgram();
        }
      });
  }

  fetchProgram() {
    this.departmentsApisService
      .findOne(this.departmentID!)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.cd.detectChanges())
      )
      .subscribe({
        next: (findOneResponse) => {
          const { data } = findOneResponse;
          this.selectedDepartment = data;
          this.departmentsService.selectedDepartment.set(
            this.selectedDepartment
          );
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }
}
